import { requestInit } from 'universal-scripts';

const initialState = false;

const animationReducer = (state = initialState, action) => {
	if (action.type === requestInit) {
		if (action.payload.cookies?.animationShown) {
			return action.payload.cookies.animationShown;
		}
	}
	if (action.type === 'animation/shown') {
		return true;
	}
	return state;
};

export default animationReducer;
